import { FormControlLabel, Switch, SwitchProps } from '@mui/material';

export interface SimpleSwitchProps extends Omit<SwitchProps, 'checked' | 'onChange'> {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export function SimpleSwitch({
  checked,
  onChange,
  label,
  disabled,
  ...switchProps
}: SimpleSwitchProps) {
  return (
    <FormControlLabel
      control={
        <Switch
          {...switchProps}
          checked={checked}
          onChange={(_event, checked) => onChange(checked)}
          disabled={disabled}
        />
      }
      label={label || ''}
    />
  );
}